const axios = require('axios');
const logger = require('../createLogger')('invokeS3ToEfs.js');

module.exports = async function({ objectKey, authorizationValue }) {
    logger.info(`copying from s3 to efs: ${objectKey}`);

    if (!objectKey) {
        logger.warn('objectKey was falsy, request not executed');
        return null;
    }

    const response = await axios({
        method: 'POST',
        url: `https://${process.env.VUE_APP_HOST_PUBLIC_API}/api/v1/s3/to/efs?file=${objectKey}`,
        data: { privateFilePath: objectKey },
        headers: {
            'Content-type': 'application/json',
            Authorization: authorizationValue,
        },
    });

    return response;
};
